<calio-mat-icon
  [iconType]="getIconName()"
  [customClass]="effectiveCustomClass"
  [height]="height"
  [width]="width"
  [tooltip]="title"
  (clickEvent)="click()"
/>
